import { useState } from "react";
import { toast } from "react-toastify";
import { exportVisits } from "@services/visits/export";
import { exportToCSV, formatCSVData } from "@utils/export";
import { formatDateTime, actualDateTime } from "@utils/formatters";
import { VISITS_EXPORT_HEADS } from "@typings/entities/visit/export";
import { VisitTypeHelper } from "@typings/entities/visit/enums";
import { getTypeLabel } from "@typings/entities/samples/enums";

export function useExportVisits() {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (locationId?: string) => {
    setIsLoading(true);
    try {
      const response = await exportVisits(locationId);

      if (!response.items?.length) {
        toast.warning("Nenhuma visita disponível para exportar");
        return;
      }

      const translatedData = response.items.map((item) => ({
        ...item,
        visitType: item.visitType
          ? VisitTypeHelper.getLabel(item.visitType)
          : "",
        sampleTypes:
          item.sampleTypes?.map((type) => getTypeLabel(type)).join(", ") ?? "",
        registeredBy: item.registeredBy ?? "",
        attachmentsCount: item.attachmentsCount ?? 0,
        date: formatDateTime(item.date),
        createdAt: formatDateTime(item.createdAt),
        updatedAt: formatDateTime(item.updatedAt),
      }));

      const formattedData = formatCSVData(translatedData, VISITS_EXPORT_HEADS);

      const fileName = `relatorio_visitas_${actualDateTime()}`;

      exportToCSV(formattedData, fileName);
      toast.success("Relatório de visitas exportado com sucesso!");
    } catch {
      toast.error("Erro ao exportar relatório de visitas");
    } finally {
      setIsLoading(false);
    }
  };

  return { handleExport, isLoading };
}
